var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgSearch = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M16.8399523,15.7792921 L21.5303301,20.4696699 C21.8232233,20.7625631 21.8232233,21.2374369 21.5303301,21.5303301 C21.2374369,21.8232233 20.7625631,21.8232233 20.4696699,21.5303301 L15.7792921,16.8399523 C14.3486717,18.0325324 12.5081226,18.75 10.5,18.75 C5.94365081,18.75 2.25,15.0563492 2.25,10.5 C2.25,5.94365081 5.94365081,2.25 10.5,2.25 C15.0563492,2.25 18.75,5.94365081 18.75,10.5 C18.75,12.5081226 18.0325324,14.3486717 16.8399523,15.7792921 L16.8399523,15.7792921 Z M15.3290907,15.2161873 C16.517579,13.9994267 17.25,12.3352464 17.25,10.5 C17.25,6.77207794 14.2279221,3.75 10.5,3.75 C6.77207794,3.75 3.75,6.77207794 3.75,10.5 C3.75,14.2279221 6.77207794,17.25 10.5,17.25 C12.3352464,17.25 13.9994267,16.517579 15.2161873,15.3290907 C15.2327733,15.3085794 15.2506009,15.2887389 15.2696699,15.2696699 C15.2887389,15.2506009 15.3085794,15.2327733 15.3290907,15.2161873 L15.3290907,15.2161873 Z"
  }));
};
export default SvgSearch;